import { mergeStyles } from '@uifabric/merge-styles';
import getLeftNavWidth from '../utils/getLeftNavWidth';
import getListViewDimensions from '../utils/getListViewDimensions';
import { isReadingPanePositionRight, isReadingPanePositionBottom } from './readingPanePosition';
import { isFeatureEnabled } from 'owa-feature-flags';
import { MIN_READING_PANE_WIDTH } from '../internalConstants';

/**
 * Gets the styles to be applied to the Left Pane container
 */
export function getLeftPaneStyles(): string {
    return mergeStyles({
        flex: '0 0 auto',
        width: getLeftNavWidth(),
    });
}

/**
 * Gets the styles to be applied to the Right Pane container
 */
export function getRightPaneStyles(): string {
    return mergeStyles({
        flex: '1 1 auto',
    });
}

/**
 * Gets the styles to be applied to the list view container
 */
export function getListViewContainerStyles(): string {
    const { listViewWidth, listViewHeight } = getListViewDimensions();

    return mergeStyles({
        width: isReadingPanePositionRight() ? listViewWidth : '',
        height: isReadingPanePositionBottom() ? listViewHeight : '',
        flex: '0 0 auto',
    });
}

/**
 * Gets the styles to be applied for the reading pane container
 */
export function getReadingPaneContainerStyles(): string {
    return mergeStyles({
        minWidth: isFeatureEnabled('tri-dynamicLayout') ? MIN_READING_PANE_WIDTH + 'px' : '',
    });
}
